import React from 'react';
import { FormattedMessage } from 'react-intl';
import { toast } from 'react-toastify';
import SuccessIcon from '../../assets/icons/notification-success.svg';
import ErrorIcon from '../../assets/icons/notification-error.svg';
import InfoIcon from '../../assets/icons/notification-info.svg';
import WarningIcon from '../../assets/icons/notification-warning.svg';

import './NotificationService.scss';

export enum MessageType {
  SUCCESS,
  WARNING,
  ERROR,
  INFO
}

const messagesOption = {
  autoClose: 3000,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
};

export class NotificationService {

  successMessage(message: string, args?: { [key: number]: string }) {
    toast.success(this.renderMsg(MessageType.SUCCESS, message, args), {
      ...messagesOption,
      position: 'bottom-right',
    });
  }

  errorMessage(message: string, args?: { [key: number]: string }) {
    toast.error(this.renderMsg(MessageType.ERROR, message, args), {
      ...messagesOption,
      position: 'bottom-right',
    });
  }

  infoMessage(message: string, args?: { [key: number]: string }) {
    toast.info(this.renderMsg(MessageType.INFO, message, args), {
      ...messagesOption,
      position: 'bottom-right',
    });
  }

  warningMessage(message: string, args?: { [key: number]: string }) {
    toast.warn(this.renderMsg(MessageType.WARNING, message, args), {
      ...messagesOption,
      position: 'bottom-right',
    });
  }

  renderMsg(msgType: MessageType, message: string, args: { [key: number]: string } = {}) {
    let icon;

    switch (msgType) {
      case MessageType.SUCCESS:
        icon = <SuccessIcon className="notification__icon"/>;
        break;
      case MessageType.ERROR:
        icon = <ErrorIcon className="notification__icon"/>;
        break;
      case MessageType.INFO:
        icon = <InfoIcon className="notification__icon"/>;
        break;
      case MessageType.WARNING:
        icon = <WarningIcon className="notification__icon"/>;
        break;
      default:
        break;
    }
    return (
      <div className="notification">
        {icon}
        <div className="notification__message">
          <FormattedMessage id={message} values={args}/>
        </div>
      </div>
    );
  }
}

export default new NotificationService();
